import { ActiveHeadsetSubscription, ReportsHeadset, Package } from 'src/models';

export const reportsHeadsetSearchQueryKeys = [
  'label',
  'id',
  'humanId',
] as const;

export const reportsHeadsetQueryKeys = [
  'companies',
  ...reportsHeadsetSearchQueryKeys,
] as const;

export type ReportsHeadsetsQueryKey = (typeof reportsHeadsetQueryKeys)[number];

export type GetReportsHeadsetsQueryParams = Partial<
  Record<ReportsHeadsetsQueryKey, string>
>;

export type GetReportsHeadsetsResponse = ReportsHeadset[];
export type GetPackagesParams = { companyId: string };

export type GetPackagesResponse = Package[];

export type ActivateHeadsetSubscriptionParams = {
  companyId: string;
  headsetId: string;
  data: { packageId: string };
};

export type ActivateHeadsetSubscriptionResponse = ActiveHeadsetSubscription;

export type CancelHeadsetSubscriptionsParams = {
  companyId: string;
  headsetId: string;
};

export type CancelHeadsetSubscriptionsResponse = ReportsHeadset;
